var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function({ on }) {
                return [
                  _c("v-icon", _vm._g({}, on), [
                    _vm._v("\n        mdi-information-outline\n      ")
                  ])
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", [
            _c("div", { staticClass: "d-flex" }, [
              _c(
                "div",
                { staticClass: "mr-2" },
                [
                  _c("div", { staticClass: "mb-2 font-weight-bold" }, [
                    _vm._v(
                      "\n            Symboles lignes du Journal :\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.logbooks, function(item) {
                    return _c(
                      "div",
                      { key: item.alert, staticClass: "mb-1" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-1", attrs: { color: item.color } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.icon) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(
                          "\n            " + _vm._s(item.alert) + "\n          "
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("div", { staticClass: "mb-2 font-weight-bold" }, [
                    _vm._v("\n            Divers :\n          ")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.divers, function(item) {
                    return _c(
                      "div",
                      { key: item.alert, staticClass: "mb-1" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-1", attrs: { color: item.color } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.icon) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(
                          "\n            " + _vm._s(item.alert) + "\n          "
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }